export function useSsr() {
    var _a;
    const isDOM = typeof window !== 'undefined' && !!((_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.documentElement);
    return {
        isBrowser: isDOM,
        isServer: !isDOM,
    };
}
